import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-644eb291"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-logs-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "Get request logs", -1))
const _hoisted_3 = { class: "filter-section" }
const _hoisted_4 = {
  class: "errors-only-filter",
  for: "errorsOnly"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Only groups with errors", -1))
const _hoisted_6 = { class: "results-summary" }
const _hoisted_7 = {
  key: 0,
  class: "expanded-group-panel"
}
const _hoisted_8 = { class: "expanded-group-header" }
const _hoisted_9 = { class: "header-primary" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "expanded-group-actions" }
const _hoisted_12 = { class: "log-count" }
const _hoisted_13 = {
  key: 0,
  class: "contract-badge"
}
const _hoisted_14 = {
  key: 1,
  class: "error-badge"
}
const _hoisted_15 = { class: "log-table-container" }
const _hoisted_16 = { class: "log-table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "40%" }, "Message"),
    /*#__PURE__*/_createElementVNode("th", { width: "60%" }, "Data")
  ])
], -1))
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "message-content" }
const _hoisted_20 = { class: "timestamp" }
const _hoisted_21 = { class: "message-text" }
const _hoisted_22 = {
  key: 0,
  class: "row-contract"
}
const _hoisted_23 = { class: "data-cell" }
const _hoisted_24 = {
  key: 0,
  class: "json-container"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "json-editor-wrapper"
}
const _hoisted_27 = {
  key: 1,
  class: "no-data"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "summary-main" }
const _hoisted_30 = { class: "header-primary" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "summary-message" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Latest event", -1))
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "group-meta" }
const _hoisted_36 = { class: "log-count" }
const _hoisted_37 = {
  key: 0,
  class: "contract-badge"
}
const _hoisted_38 = {
  key: 1,
  class: "error-badge"
}
const _hoisted_39 = { class: "summary-toggle-indicator" }
const _hoisted_40 = {
  key: 1,
  class: "no-logs-message"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No logs found for the selected filters", -1))
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_json_editor_vue = _resolveComponent("json-editor-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_input, {
        id: "fromdate",
        label: "From date (optional)",
        type: "date",
        modelValue: _ctx.fromDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event)),
        class: "date-picker"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_input, {
        id: "requestId",
        label: "Work order number (optional)",
        type: "text",
        modelValue: _ctx.requestId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestId) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_input, {
        id: "contract",
        label: "Contract (optional)",
        type: "text",
        modelValue: _ctx.contract,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contract) = $event)),
        class: "contract-filter"
      }, null, 8, ["modelValue"]),
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          id: "errorsOnly",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.errorsOnly) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.errorsOnly]
        ]),
        _hoisted_5
      ]),
      _createVNode(_component_base_button, {
        onClick: _ctx.getLogs,
        text: "Get logs",
        class: "btn-primary"
      }, null, 8, ["onClick"])
    ]),
    (_ctx.apiResponse && _ctx.apiResponse.groups.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.apiResponse.groups.length) + " groups", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.totalEventCount) + " events", 1)
          ]),
          (_ctx.expandedGroup)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.formatDate(_ctx.expandedGroup.loggedOnDate)), 1),
                    _createElementVNode("span", {
                      class: "correlation-id",
                      title: _ctx.expandedGroup.correlationId || undefined
                    }, _toDisplayString(_ctx.expandedGroup.correlationId || 'No correlation id'), 9, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.expandedGroup.eventCount) + " events", 1),
                    (_ctx.expandedGroup.contracts.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatContracts(_ctx.expandedGroup.contracts)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.expandedGroup.hasErrors)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Contains errors"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "summary-toggle-btn",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleGroup(_ctx.expandedGroup)))
                    }, " Hide details ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("table", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expandedGroup.rows, (row, rowIndex) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: _ctx.getRowKey(_ctx.expandedGroup, row, rowIndex),
                          class: _normalizeClass({
                  'row-error': row.level === 'Error',
                  'row-warning': row.level === 'Warning',
                  'row-info': row.level === 'Info' || !row.level
                })
                        }, [
                          _createElementVNode("td", {
                            class: "message-cell",
                            title: row.message + '\n' + row.additionalInfo
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatTime(row.loggedOnDate)), 1),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(row.message), 1),
                              (row.contract)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row.contract), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_18),
                          _createElementVNode("td", _hoisted_23, [
                            (row.contextData)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.toggleRowExpand(_ctx.expandedGroup, row, rowIndex)),
                                    class: "toggle-btn"
                                  }, _toDisplayString(_ctx.isRowExpanded(_ctx.expandedGroup, row, rowIndex) ? '▼' : '►') + " " + _toDisplayString(_ctx.getDataSummary(row.contextData)), 9, _hoisted_25),
                                  (_ctx.isRowExpanded(_ctx.expandedGroup, row, rowIndex))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _createVNode(_component_json_editor_vue, _mergeProps({
                                          "model-value": row.contextData
                                        }, { readOnly: true, mainMenuBar: false, navigationBar: false }), null, 16, ["model-value"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_27, "No data"))
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _mergeProps(_ctx.containerProps, { class: "virtual-log-container" }), [
            _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.wrapperProps)), [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (virtualGroup) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: _ctx.getGroupKey(virtualGroup.data, virtualGroup.index),
                  class: "log-group-summary"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["log-group-summary-card", { 'log-group-summary-card--active': _ctx.isExpandedGroup(virtualGroup.data) }]),
                    onClick: ($event: any) => (_ctx.toggleGroup(virtualGroup.data))
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.formatDate(virtualGroup.data.loggedOnDate)), 1),
                        _createElementVNode("span", {
                          class: "correlation-id",
                          title: virtualGroup.data.correlationId || undefined
                        }, _toDisplayString(virtualGroup.data.correlationId || 'No correlation id'), 9, _hoisted_31)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("span", {
                          class: "summary-text",
                          title: _ctx.getSummaryMessage(virtualGroup.data)
                        }, _toDisplayString(_ctx.getSummaryMessage(virtualGroup.data)), 9, _hoisted_34)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(virtualGroup.data.eventCount) + " events", 1),
                      (virtualGroup.data.contracts.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.formatContracts(virtualGroup.data.contracts)), 1))
                        : _createCommentVNode("", true),
                      (virtualGroup.data.hasErrors)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Contains errors"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.isExpandedGroup(virtualGroup.data) ? 'Hide details' : 'Show details'), 1)
                    ])
                  ], 10, _hoisted_28)
                ]))
              }), 128))
            ], 16)
          ], 16)
        ], 64))
      : (_ctx.apiResponse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
        : _createCommentVNode("", true)
  ]))
}